export default __webpack_public_path__ + "img/ca6a21114901295ba32bc9be00915160.png";